import React from 'react';
import PropTypes from 'prop-types';

import CrudContext from 'react/contexts/DefaultContext';
import GeneralSection from 'react/containers/pages/TicketDetails/TicketDetailsContainer/GeneralSection';
import AttachmentsSection from 'react/containers/pages/TicketDetails/TicketDetailsContainer/AttachmentsSection';
import TasksRelatedSection from 'react/containers/pages/TicketDetails/TicketDetailsContainer/TasksRelatedSection';
import CommentsSection from 'react/containers/pages/TicketDetails/TicketDetailsContainer/CommentsSection';

function TicketDetailsContainer(props) {
  const {
    className, tab: { key: screenKey }, isLoading, data, isLoadingChatData
  } = props;
  const isGrid = false;
  const entity = 'TicketDetails';

  return (
    <CrudContext.Provider value={{ entity, isGrid }}>
      <div id={screenKey} className={`${className} generalForm`}>
        <GeneralSection isLoading={isLoading} data={data} />
        <AttachmentsSection isLoadingChatData={isLoadingChatData} data={data} />
        <TasksRelatedSection isLoading={isLoading} data={data} />
        <CommentsSection {...props} />
      </div>
    </CrudContext.Provider>
  );
}

TicketDetailsContainer.propTypes = {
  className: PropTypes.string,
  tab: PropTypes.shape({
    key: PropTypes.string.isRequired
  }),
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.object,
  isLoadingChatData: PropTypes.bool.isRequired
};

TicketDetailsContainer.defaultProps = {
  className: '',
  tab: {}
};

export default TicketDetailsContainer;
